import { get, patch, post } from './fetch';
import type {
  EmployeeReportRequestFilters,
  SellerReportRequestFilters,
  StateTreeNode,
} from '../pages/admin/reports/reports.types';

export const saveTest = async (materialId: number, questions: any, answers: any): Promise<void> => {
  await post('/test/save', { materialId, questions, answers });
};

export const questionsList = async (id: number):
  Promise<Array<{
    text: string,
    rightAnswersCount: number,
    answers: Array<{ id: number, text: string, isRight: number }>
  }>> => {
  return await get('/test/questions?id=' + id);
};

export const userPrizes = async (userId: number):
  Promise<{
    success: Array<{
      prize: number,
      attemptsCount: number,
      updatedAt: string,
      name: string
    }>
  }> => {
  return await get('/test/userPrizes?userId=' + userId);
};

export const dashboardData = async (period: Array<string>, userType: string = 'all'): Promise<{
  allUsersCount: number;
  periodUsersCount: number;
  allAttendanceCount: number;
  periodAttendanceCount: number;
  allTestCount: number;
  periodTestCount: number;
  sumPrize: number;
  periodSumPrize: number;
  attendanceByState: { state: string; count: number }[];
  prizeByState: { state: string; prize: number }[];
  prizeByUser: { fio: string; state: string; prize: number }[];
  allTestsPopularity: { id: number; name: string; imgSource: string; popularity: number }[];
  attendanceChart: { name: string; attendance: number; testAttempts: number }[];
}> => {
  return await post('/user/dashboard', { period, userType });
};

export const getReport = async (filters: EmployeeReportRequestFilters): Promise<Blob> => {
  return await post('/admin/report', filters, true, 'blob');
};

export const getReportForSellers = async (filters: SellerReportRequestFilters): Promise<Blob> => {
  return await post('/admin/reportForSellers', filters, true, 'blob');
};

export const getManagerList = async (id: number | null): Promise<Array<{ id: number, name: string }>> => {
  return await get('/admin/managers?stateId=' + id);
};

export const getNotifications = (): Promise<{ unapprovedPrizeCount: number, notifications: any[] }> => {
  return get('/admin/notifications');
};

export const markNotificationsAsRead = async () => {
  return patch("/admin/notifications/mark-read", {});
};

export const handlePrizeRequest = async (prizeId: number, status: number, reason: string) => {
  return post('/test/handlePrizeRequest', { prizeId, status, reason });
};

export const getAllStates = async (type: string = 'F'): Promise<[{ name: string, id: number }]> => {
  return get('/admin/allStates?type=' + type);
};

export const getStatesTree = async (): Promise<StateTreeNode[]> => {
  return get('/admin/statesTree');
};

export const getRoles = async (): Promise<Array<{ id: number, name: string }>> => {
  return get('/auth/roles');
};

export const setMaterialAccess = async () => {
  return post('/admin/setMaterialAccess', {});
};

export const getStateUsersByClients = async (stateId: number, period: {start: string, end: string}, materials: string[]): Promise<any> => {
  return post(`/admin/stateUsers`, {
    stateId,
    period,
    materials
  });
};

export const createState = async (parentId:number, name: string, type: string, isLp: boolean = false): Promise<any> => {
  return post('/admin/createState', {parentId, name, type, isLp});
};

export const getOneState = async (id: number): Promise<{ name: string; id: number; type: string }> => {
  return get(`/states/${id}`);
};